module.exports = __webpack_public_path__ + "img/logo.0a003e2f.png";